module.exports = __webpack_public_path__ + "static/media/moon.e949a9d4.png";